import { PlateTypeEnum } from "@ns/types";

export const plateTypeMapper = (type: string) => {
  switch (type) {
    case PlateTypeEnum.COMMERCIAL_STONE:
      return "KOMERCIJALNI KAMEN";
    case PlateTypeEnum.TABLE:
      return "TABLA";
    case PlateTypeEnum.READY_FORMATS:
      return "GOTOV FORMAT";
  }
};
